<div [formGroup]="parentFormGroup">
  @if (parentFormGroup.get(field.formControlName); as control) {
    @if (field.type === 'hidden') {
      <input [formControlName]="field.formControlName" type="hidden" />
    }
    @if (field.type !== 'hidden') {
      <!-- linter cannot see the label/component nesting due to the angular if's -->
      <!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
      <label class="text-lg font-medium text-primary-text">
        {{ field.labelKey | translate }}&ThinSpace;
        @if (isRequired(control)) {
          <span>
            *
            <span class="sr-only">{{
              'common.fieldValidation.labelRequired' | translate
            }}</span>
          </span>
        }
        @if (field.type === 'text') {
          <input
            class="input mt-2 w-full max-w-lg flex-grow"
            [formControlName]="field.formControlName"
            [ngClass]="{ 'input-invalid': shouldShowErrors(control) }"
            [placeholder]="
              field.placeholderKey ? (field.placeholderKey | translate) : ''
            "
            [type]="field.type"
          />
        }
        @if (field.type === 'select') {
          <dhp-select-input
            class="mt-2 w-full max-w-lg flex-grow"
            [formControlName]="field.formControlName"
            [options]="toSelectOptions(field.options)"
            [required]="isRequired(control)"
          ></dhp-select-input>
        }
        @if (field.type === 'checkbox') {
          <div class="mt-2">
            <input
              class="checkbox"
              [formControlName]="field.formControlName"
              type="checkbox"
            />
          </div>
        }
      </label>
      <div
        class="text-sm text-red-700 transition-all"
        [ngClass]="shouldShowErrors(control) ? 'mt-2 h-5' : 'h-0'"
        role="alert"
      >
        @if (shouldShowErrors(control)) {
          <div>
            @for (error of getControlErrors(control); track error.key) {
              <span class="error-message">
                {{
                  field.errorKeys?.[error.key] ??
                    'common.fieldValidation.missingValidationKey'
                    | translate
                      : { key: error.key, value: error.value.actualValue }
                }}
              </span>
            }
          </div>
        }
      </div>
    }
  }
</div>
